import React, { Component } from 'react';
import { connect } from 'react-redux';
import InPlay from '..';
import SearchBar from './SearchBar';
import * as Maps from '../../../store/map';

class Search extends Component {
    componentDidMount() {
        this.props.lsportsActions.inplay.selectSport(null);
        //this.props.clearSearch();
    }

    render() {
        return (
            <div className="main-container">
                <SearchBar />
                <InPlay />
            </div>
        );
    }
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(Search);
